export default [
    {
        path: "/toolkit/prompt/image",
        name: "toolkit-prompt-image",
        component: () => import("@/views/toolkit/prompt/image.vue"),
    },
    {
        path: "/toolkit/prompt/video",
        name: "toolkit-prompt-video",
        component: () => import("@/views/toolkit/prompt/video.vue"),
    },
    {
        path: "/toolkit/search/xhs",
        name: "toolkit-search-xhs",
        component: () => import("@/views/toolkit/search/xhs.vue"),
    },
    {
        path: "/toolkit/search/dy",
        name: "toolkit-search-dy",
        component: () => import("@/views/toolkit/search/dy.vue"),
    },
    {
        path: "/toolkit/hotlist",
        name: "toolkit-hotlist",
        component: () => import("@/views/toolkit/hotlist.vue"),
    },
]